import { useState } from 'react'
import { TQuoteFilters } from '../../../types'

interface IUsePriceRequestIdProps {
  quotesFilters: TQuoteFilters
  setQuotesFilters: React.Dispatch<React.SetStateAction<TQuoteFilters>>
}

export const usePriceRequestId = ({ quotesFilters, setQuotesFilters }: IUsePriceRequestIdProps) => {
  const [priceRequestId, setPriceRequestId] = useState<string | undefined>(
    quotesFilters.priceRequestId
  )
  const clearPriceRequestIdHandler = () => {
    const updatedQuotes = { ...quotesFilters }
    delete updatedQuotes.priceRequestId
    setQuotesFilters({ ...updatedQuotes })
    setPriceRequestId('')
  }

  const submitPriceRequestIdHandler = () => {
    if (priceRequestId === '' || priceRequestId === undefined) {
      clearPriceRequestIdHandler()
    } else {
      setQuotesFilters({ ...quotesFilters, priceRequestId })
    }
  }
  const typePriceRequestIdHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPriceRequestId(event.target.value)
  }
  return {
    priceRequestId,
    submitPriceRequestIdHandler,
    typePriceRequestIdHandler,
    clearPriceRequestIdHandler,
  }
}
